import * as React from 'react'

import { Checkbox, Radio } from 'main/ui'
import { UnreachableCaseError } from 'main/util/ts'

interface IProps {
  selected: boolean
  type: 'radio' | 'checkbox'
  onChangeSelected: (selected: boolean) => void
}

export default function Selector(props: IProps) {
  const { selected, type, onChangeSelected } = props

  switch (type) {
    case 'radio':
      return <Radio checked={selected} onChange={onChangeSelected} />
    case 'checkbox':
      return <Checkbox checked={selected} onChange={onChangeSelected} />
    default:
      throw new UnreachableCaseError(type)
  }
}
